export const validEmail = (value: string) => {
  const email = value.replace(/[\s]/gi, '');

  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};
